exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".second-col {\n    display: none;\n}\n\n@media only screen and (min-width: 768px) {\n    .second-col {\n        display: inline-block;\n    }\n\n    .first-col {\n        display: none;\n    }\n}", ""]);

// exports
